function ProjectPageFunctionality() {
    const projectLogoRevealSection = document.querySelector('.project-page__portfolio-logo')
    const projectLogoReveal = document.querySelector('.project-page__portfolio-logo-reveal')
    const projectParallaxItem = document.querySelectorAll('.project-parallax-item')

    if (projectLogoReveal) {
        gsap.to(projectLogoReveal, {
            duration: 2,
            scrollTrigger: {
                trigger: projectLogoRevealSection,
                start: "top 0%",
                end: "center 95%",
                scrub: 1
            },
            opacity: 1        
        })
    }
    
    if (projectParallaxItem) {
        projectParallaxItem.forEach((item, index) => {
            gsap.to(item, {
                backgroundPosition: "0% 100%",
                ease: "none",
                scrollTrigger: {
                    trigger: item,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true
                }
            })
        })
    }
}

export default ProjectPageFunctionality